export enum ESummaryCardType {
  VALUE = 'VALUE',
  PERCENTAGE = 'PERCENTAGE',
  CURRENCY = 'CURRENCY',
  NO_DATA = 'NO_DATA',
}
